<template>
  <div>
    <div class="wrapper">
      <comheader :index="3"></comheader>
      <main id="content" role="main">
        <input type="hidden" name="hdnAgeText" id="hdnAgeText" value="Age" />
        <input
          type="hidden"
          name="hdnDateTimeText"
          id="hdnDateTimeText"
          value="Date Time (UTC)"
        />
        <input
          type="hidden"
          name="hdnAgeTitle"
          id="hdnAgeTitle"
          value="Click to show Age Format"
        />
        <input
          type="hidden"
          name="hdnDateTimeTitle"
          id="hdnDateTimeTitle"
          value="Click to show Datetime Format"
        />
        <input
          type="hidden"
          name="hdnTxnText"
          id="hdnTxnText"
          value="Txn Fee"
        />
        <input
          type="hidden"
          name="hdnGasPriceText"
          id="hdnGasPriceText"
          value="Gas Price"
        />
        <input
          type="hidden"
          name="hdnTxnFeeTitle"
          id="hdnTxnFeeTitle"
          value="(Gas Price * Gas Used by Txns) in Ether"
        />
        <input
          type="hidden"
          name="hdnGasPriceTitle"
          id="hdnGasPriceTitle"
          value="Gas Price in Gwei"
        />
        <div class="container space-2">
          <div class="w-md-75 w-lg-50 mx-md-auto">
            <div class="text-center mb-4">
              <h2 class="h3 mb-1">Verify Address Ownership</h2>
              <p>
                Find out more about
                <a
                  href="https://info.etherscan.com/what-is-verify-address-ownership/"
                  target="_blank"
                  >Verify Address Ownership</a
                >
              </p>
            </div>
            <div class="card">
              <div class="card-body p-4">
                <form
                  method="post"
                  action=""
                  id="form1"
                  class="js-validate"
                  novalidate="novalidate"
                >
                  <div class="aspNetHidden">
                    <input
                      type="hidden"
                      name="__EVENTTARGET"
                      id="__EVENTTARGET"
                      value=""
                    />
                    <input
                      type="hidden"
                      name="__EVENTARGUMENT"
                      id="__EVENTARGUMENT"
                      value=""
                    />
                    <input
                      type="hidden"
                      name="__VIEWSTATE"
                      id="__VIEWSTATE"
                      value="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"
                    />
                  </div>

                  <div class="aspNetHidden">
                    <input
                      type="hidden"
                      name="__VIEWSTATEGENERATOR"
                      id="__VIEWSTATEGENERATOR"
                      value="B0F30D6A"
                    />
                    <input
                      type="hidden"
                      name="__EVENTVALIDATION"
                      id="__EVENTVALIDATION"
                      value="qVrZXBblM1hp9vvy9eCy+8KYy2+/fjbAzInUAiuEd0mE7jpKK6Opv9ltawchyNyC+a6H01C29JnMjpU9q/1QHCyXpDt6oGpx54gmx2NVC9GmCNR8U47LpD/S59VQKawCdyLtTbo9h2a/Vywvi0ZzsAukgcTgUysyAeDhe6UAx/gV9s7cLBwXb8nsoGJX2B5dB3cDaQA23DiRKBdxqPeNa3S+L/vz6CPxiga9gXWxYHk="
                    />
                  </div>
                  <div id="ContentPlaceHolder1_verifyaddress2div">
                    <div class="row mb-4">
                      Copy the message below and sign it using the Ethereum sign
                      message provider of your choice.
                    </div>
                    <div class="js-form-message form-group">
                      <div
                        id="ContentPlaceHolder1_ContractCreator"
                        class="custom-control custom-radio"
                      >
                        <input
                          value="0x36928500bc1dcd7af6a2b4008875cc336b927d57"
                          name="ctl00$ContentPlaceHolder1$ContractOwnerCreator"
                          type="radio"
                          id="ContentPlaceHolder1_RadioButton0"
                          class="custom-control-input"
                          checked="checked"
                        /><label
                          class="custom-control-label"
                          for="ContentPlaceHolder1_RadioButton0"
                          >Contract Creator: {{ creator }}</label
                        >
                      </div>
                    </div>
                    <div class="js-form-message form-group">
                      <label
                        class="
                          d-flex
                          justify-content-between
                          align-items-center
                        "
                        for="signedMessage"
                      >
                        <span>Message To Sign</span>
                        <a
                          class="
                            js-clipboard
                            btn btn-sm btn-icon btn-soft-primary
                            rounded-circle
                          "
                          href="javascript:;"
                          data-toggle="tooltip"
                          title=""
                          data-content-target="#ContentPlaceHolder1_txtRawMessage"
                          data-class-change-target="#copyLinkIcon"
                          data-default-class="far fa-copy"
                          data-success-class="fa fa-check"
                          data-original-title="Copy message to sign to clipboard"
                          ><i
                            id="copyLinkIcon"
                            class="far fa-copy btn-icon__inner"
                          ></i
                        ></a>
                      </label>
                      <textarea
                        name="ctl00$ContentPlaceHolder1$txtRawMessage"
                        rows="3"
                        cols="20"
                        id="ContentPlaceHolder1_txtRawMessage"
                        disabled="disabled"
                        class="aspNetDisabled form-control form-control-sm"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                        v-model="message"
                      ></textarea>
                    </div>
                    <div class="row">
                      <p>
                        Check our article on "<a
                          rel="nofollow noopener"
                          href="https://info.etherscan.com/how-to-verify-address-ownership/"
                          target="_blank"
                          >How to Sign Message?</a
                        >" if you have not done before.
                      </p>
                    </div>
                    <div class="d-flex justify-content-center">
                      <input
                        type="hidden"
                        name="ctl00$ContentPlaceHolder1$SignedWeb3Message"
                        id="ContentPlaceHolder1_SignedWeb3Message"
                      />
                      <div
                        class="justify-content-between align-items-center"
                        align="center"
                      >
                        <input
                          type="submit"
                          name="ctl00$ContentPlaceHolder1$btnSubmit2"
                          value="Sign Message Manually"
                          @click="toManully"
                          id="ContentPlaceHolder1_btnSubmit2"
                          class="btn btn-sm btn-primary"
                        />
                        <span class="text-secondary px-2">OR</span>
                        <input
                          type=""
                          name="ctl00$ContentPlaceHolder1$btnConnectOrSign"
                          :value="value"
                          @click="signTX"
                          id="ContentPlaceHolder1_btnConnectOrSign"
                          class="btn btn-sm btn-primary"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="modal fade"
                    id="myModal"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="myModalLabel"
                    aria-hidden="true"
                  >
                    <div
                      class="modal-dialog modal-dialog-centered"
                      role="document"
                    >
                      <div class="modal-content">
                        <div class="modal-header p-2">
                          <h5
                            class="
                              pl-3
                              modal-title
                              h6
                              font-weight-bold
                              text-break
                              w-100
                              mt-2
                              mb-2
                            "
                          >
                            Contract Created By Contract
                          </h5>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </div>
                        <div class="modal-body ml-1">
                          <p class="mt-1 mb-2">
                            We are not able to automatically verify and assign
                            the ownership of this contract address. Please refer
                            to and follow the instructions in our article
                            <a
                              href="https://info.etherscan.com/contract-created-by-contract/"
                              >here</a
                            >
                            and
                            <a
                              href="/contactus?id=1&amp;parent=verifyAddress&amp;case=1"
                              >contact us</a
                            >
                            afterward with the required signed message.
                          </p>
                        </div>
                        <div class="modal-footer">
                          <button
                            data-dismiss="modal"
                            class="btn btn-sm btn-secondary btn-xs cancel"
                            type="button"
                            causesvalidation="False"
                          >
                            Cancel
                          </button>
                          <a
                            href="/contactus?id=1&amp;parent=verifyAddress&amp;case=1"
                            class="btn btn-sm btn-primary btn-xs"
                            >Proceed To Contact Us</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <comfooter></comfooter>
  </div>
</template>
<script>
import comheader from "@/components/comheader";
import comfooter from "@/components/comfooter";
import { ethers } from "ethers";
import moment from "moment";
import Web3 from "web3";
export default {
  data() {
    return {
      provider: {},

      creator: "",
      address: "",
      message: "",
      value: "Sign with Web3",
      signData: "",
      web3: {},
      account: "",
    };
  },
  components: {
    comheader,
    comfooter,
  },
  async mounted() {
    let that = this;

    if (typeof web3 !== "undefined") {
      that.web3 = new Web3(web3.currentProvider);
    } else {
      // set the provider you want from Web3.providers
      that.web3 = new Web3(new Web3.providers.HttpProvider(window.ethereum));
    }

    if (JSON.stringify(that.$route.params) != "{}") {
      that.creator = that.$route.params.creator;
      that.address = that.$route.params.address;

      sessionStorage.setItem("creator_addr", that.creator);
      sessionStorage.setItem("contract_addr", that.address);
    } else {
      that.creator = sessionStorage.getItem("creator_addr");
      that.address = sessionStorage.getItem("contract_addr");
    }

    that.message = `[Pscscan.io ${moment()
      .utc()
      .format(
        "D/MM/YYYY h:mm:ss"
      )}] I, hereby verify that I am the creator of the address [${
      that.address
    }]`;

    if (window.ethereum) {
      try {
        that.provider = new ethers.providers.Web3Provider(window.ethereum);
      } catch (e) {

      }
    }
  },
  methods: {
    toManully() {
      let that = this;

      that.$router.push({
        name: "verifyaddress_manully",
        params: {
          address: that.address,
          creator: that.creator,
          message: that.message,
        },
      });
    },
    async signTX() {
      let that = this;

      if (that.value == "Sign with Web3") {
        let data;
        await window.ethereum.enable().then((res) => {
          that.account = res[0];
        });
        try {


          data = await that.web3.eth.personal.sign(that.message, that.account);

        } catch (error) {
      
        }

        that.signData = data;

        that.value = "Click to Proceed";
      } else {
        that.$router.push({
          name: "verifyaddress_manully",
          params: {
            address: that.address,
            creator: that.creator,
            message: that.message,
            signData: that.signData,
          },
        });
      }
    },
  },
};
</script>
